
import { MaterialInput } from 'app/components';
import { Container, IAppState } from 'app/containers/Container';
import { AdminAction } from 'app/redux/Admin/actions';
import { IUserState } from 'app/redux/User/reducer';
import * as React from 'react';
import { Alert, Button, Col, FormGroup, Panel, Row } from 'react-bootstrap';

class UserAdd extends Container<{}, {}> {
  state = {
    username: '',
    firstname: '',
    lastname: '',
    password: '',
    email: '',
    error: null,
    admin: null
  }

  componentWillMount() {
    super.componentWillMount()
  }

  mapAppStateToContainerState(appState: IAppState): {} {
    return {
      username: this.state.username,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      password: this.state.password,
      email: this.state.email,
      error: '',
      admin: appState.User
    }
  }

  addUser(e) {
    AdminAction.addUser(
      this.state.username,
      this.state.password,
      this.state.firstname,
      this.state.lastname,
      this.state.email,
      this.state.admin.token,
      this.state.admin.accesstoken)
      .then(() => {
        location.hash = '#/useradmin'
      }, (error) => {
        this.setState({ error })
      })
      .catch()
  }

  setPartialState(attr: string, value: any) {
    const updateState = {}
    updateState[attr] = value

    this.state.error = null

    this.setState(updateState)
  }

  render() {
    return (
      <section className="container padding-top-lg">
        <Row>
          <Col mdOffset={3} md={6}>
            <h6>
              To add a user fill in the fields below
              </h6>
            <Panel className="animated fadeIn">
              <form name="registrationFrom" onSubmit={(e) => this.addUser(e)}>
                <FormGroup>
                  <MaterialInput placeholder="Username"
                    required={true}
                    onChange={(value) => this.setPartialState('username', value)}
                    value={this.state.username} />
                </FormGroup>
                <FormGroup>
                  <MaterialInput placeholder="Password"
                    required={true}
                    type="password"
                    onChange={(value) => this.setPartialState('password', value)}
                    value={this.state.password} />
                </FormGroup>
                <FormGroup>
                  <MaterialInput placeholder="First Name"
                    required={true}
                    onChange={(value) => this.setPartialState('firstname', value)}
                    value={this.state.firstname} />
                </FormGroup>
                <FormGroup>
                  <MaterialInput placeholder="Last Name"
                    required={true}
                    onChange={(value) => this.setPartialState('lastname', value)}
                    value={this.state.lastname} />
                </FormGroup>
                <FormGroup>
                  <MaterialInput placeholder="Email"
                    required={true}
                    onChange={(value) => this.setPartialState('email', value)}
                    value={this.state.email} />
                </FormGroup>
                <FormGroup>
                  <Button type="submit" bsStyle="success">
                    Add User
                    </Button>
                </FormGroup>

                {this.state.error ?
                  <FormGroup>
                    <Alert bsStyle="danger" className="animated fadeIn">
                      <strong>
                        <i className="fa fa-fw fa-exclamation-circle" />
                        Uh oh! {this.state.error.message}
                      </strong>
                      <span>
                      </span>
                    </Alert>
                  </FormGroup>
                  : null
                }
              </form>
            </Panel>
          </Col>
        </Row>
      </section>
    )
  }
}

export {
  UserAdd
}



// WEBPACK FOOTER //
// ./src/app/containers/UserAdd/index.tsx